<span class="has-feedback">
  @if (showError()) {
  <fa-icon
    class="form-control-feedback"
    [icon]="['fas', 'exclamation-triangle']"
    data-testing-id="exclamation-triangle-icon"
  />
  } @else {
  <span class="has-success">
    @if (field()?.props?.showValidation ? field().props.showValidation(field()) : defaultShowValidation()) {
    <fa-icon class="form-control-feedback" [icon]="['fas', 'check']" data-testing-id="check-icon" />
    }
  </span>
  }
</span>
